const en = {
  app_name: "JMS ERP",
  loading: "Loading…",
  save: "Save",
  cancel: "Cancel",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  search: "Search",
  actions: "Actions",
  confirm_delete: "Are you sure you want to delete?",
  yes: "Yes",
  no: "No",
  optional: "optional",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  filter: "Filter",
  clear: "Clear",
  all: "All",

  login_title: "Sign in to your account",
  login_subtitle: "Manage customers, services and payments with clarity.",
  email: "Email",
  password: "Password",
  sign_in: "Sign in",
  signing_in: "Signing in…",
  invalid_credentials: "Invalid email or password",
  logout: "Log out",

  nav_dashboard: "Dashboard",
  nav_customers: "Customers",
  nav_services: "Services",
  nav_payments: "Payments",
  nav_balance: "Balance",
  nav_documents: "Documents",
  nav_appointments: "Appointments",
  nav_settings: "Settings",

  total_customers: "Total Customers",
  total_services: "Total Services",
  total_payments: "Total Payments",
  outstanding_balance: "Outstanding Balance",
  recent_payments: "Recent Payments",
  no_recent_payments: "No recent payments.",
  amount: "Amount",
  method: "Method",
  date: "Date",

  customers_title: "Customers",
  customers_subtitle: "Manage your customers and contact details.",
  full_name: "Full Name",
  phone: "Phone",
  whatsapp: "WhatsApp",
  address: "Address",
  notes: "Notes",
  add_customer: "New Customer",
  edit_customer: "Edit Customer",
  no_customers: "No customers yet.",

  services_title: "Services",
  services_subtitle: "Register the services offered by your company.",
  service_name: "Service Name",
  description: "Description",
  price: "Price",
  add_service: "New Service",
  edit_service: "Edit Service",
  no_services: "No services yet.",

  payments_title: "Payments",
  payments_subtitle: "Record payments and track remaining balance.",
  customer: "Customer",
  service: "Service",
  service_price: "Service Price",
  amount_paid: "Amount Paid",
  payment_date: "Payment Date",
  payment_method: "Payment Method",
  remaining_balance: "Remaining Balance",
  add_payment: "New Payment",
  edit_payment: "Edit Payment",
  no_payments: "No payments yet.",
  method_cash: "Cash",
  method_pix: "PIX",
  method_bank: "Bank Transfer",
  method_card: "Card",
  select_customer: "Select a customer",
  select_service: "Select a service",
  select_method: "Select a method",

  balance_title: "Balance",
  balance_subtitle: "Consolidated view of payments and balances.",
  total_price: "Total Price",
  total_paid: "Total Paid",
  only_pending: "Only pending",
  no_balance: "No balance to display.",

  settings_title: "Settings",
  settings_subtitle: "Company and user preferences.",
  company_settings: "Company",
  company_name: "Company Name",
  company_logo: "Logo URL",
  currency: "Currency",
  language: "Language",
  user_profile: "User Profile",
  name: "Name",
  current_password: "Current Password",
  new_password: "New Password",
  update_profile: "Update Profile",
  update_company: "Update Company",
  saved_successfully: "Saved successfully",

  created: "Created successfully",
  updated: "Updated successfully",
  deleted: "Deleted successfully",
  error_generic: "Something went wrong. Please try again.",

  // AP-165 Fase 2 · Services
  svc_pricing_type: "Pricing Type",
  svc_per_service: "Charged per Service",
  svc_per_unit: "Charged per Unit",
  svc_per_time: "Charged per Time",
  svc_hint_per_unit: "The client buys multiple units (e.g. photocopy, 3x4 photo).",
  svc_hint_per_time: "Charged by duration (e.g. consultation per hour).",
  svc_hint_per_service: "Flat price per service.",
  svc_unit_label: "Unit of Measure",
  svc_unit_ph_time: "Hour",
  svc_unit_ph_unit: "Page, Copy, Photo…",
  svc_price_per_unit: "Price per Unit",
  svc_price_per_hour: "Price per Hour",

  // AP-165 Fase 2 · Customers
  cus_view: "View:",
  cus_visible: "Visible",
  cus_hidden: "Hidden",
  cus_contact: "Contact",
  cus_hidden_badge: "Hidden client",
  cus_open: "Open",
  cus_show: "Show client",
  cus_hide: "Hide client",
  cus_delete_title: "Delete Client",
  cus_delete_desc_1: "The client {name} will be removed from the main list, but all their data will remain stored in the system.",
  cus_delete_desc_2: "The Master user can restore them later from the Trash.",
  cus_delete_confirm_q: "Do you want to continue?",
  cus_attention: "WARNING",
  cus_show_title: "Show Client",
  cus_show_desc: "Do you want to restore the client {name} to the view of all authorized users?",
  cus_hide_desc: "Do you want to hide the client {name}? All data will remain saved. The client will simply stop appearing to regular users.",
  cus_hide_reason_label: "Reason (optional)",
  cus_hide_reason_ph: "e.g. Archived client, internal review…",
  cus_btn_show: "Show",
  cus_btn_hide: "Hide",

  // AP-165 Fase 2 · Payments
  pay_combobox_placeholder: "Search by name, CPF, WhatsApp, email, or case…",
  pay_combobox_search_ph: "Type to search…",
  pay_combobox_searching: "Searching…",
  pay_combobox_empty: "No clients found.",
  pay_discount_promocao_jms: "JMS Promo",
  pay_discount_desconto_comercial: "Commercial Discount",
  pay_discount_cliente_fidelizado: "Loyal Client",
  pay_discount_ajuste_preco: "Price Adjustment",
  pay_discount_campanha_especial: "Special Campaign",
  pay_discount_outro: "Other",
};

export default en;
